(() => {
  if (!('IntersectionObserver' in window) || !('ResizeObserver' in window)) return;
  const desktop = matchMedia('(min-width: 1100px)');
  document.querySelectorAll('[data-circuit-poster]').forEach(container => {
    const stylesheet = new URL(container.dataset.circuitPosterCss, location.href);
    const script = new URL(container.dataset.circuitPosterJs, location.href);
    if (stylesheet.origin !== location.origin || script.origin !== location.origin) return;
    const attribute = value => value.replaceAll('&', '&amp;').replaceAll('"', '&quot;');
    let frame = null;
    let timeout = null;
    let nearby = false;
    let failed = false;
    let pixelRatio = 1;
    const fit = () => {
      const scale = container.clientWidth / 1280;
      pixelRatio = Math.max(0.5, Math.min(8, scale * (window.devicePixelRatio || 1)));
      if (!frame) return;
      frame.style.transform = `scale(${scale})`;
      frame.contentWindow?.postMessage({type: 'kk-circuit-poster-density', pixelRatio}, location.origin);
    };
    const remove = () => {
      clearTimeout(timeout);
      frame?.remove();
      frame = null;
      delete container.dataset.circuitPosterReady;
    };
    const fail = () => { failed = true; remove(); };
    const mount = () => {
      if (!desktop.matches || document.hidden) { remove(); return; }
      if (!nearby || frame || failed) return;
      frame = document.createElement('iframe');
      frame.className = 'simulation-poster-frame';
      frame.title = container.querySelector('img').alt;
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('inert', '');
      frame.tabIndex = -1;
      frame.referrerPolicy = 'same-origin';
      frame.addEventListener('error', fail, {once: true});
      fit();
      frame.srcdoc = `<!doctype html>
        <html lang="de" class="kk-app-viewport kk-circuit-poster" data-poster-pixel-ratio="${pixelRatio}">
        <head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1">
        <title>Kälte-Klar Kältekreislauf</title><link rel="stylesheet" href="${attribute(stylesheet.href)}">
        <style>
          html.kk-circuit-poster,html.kk-circuit-poster body{margin:0;padding:0;width:100%;height:100%;overflow:hidden;background:#061923;pointer-events:none}
          #circuit-poster-root{width:1280px;height:720px;overflow:hidden}
          #circuit-poster-root>main{width:1280px;height:720px;min-height:0;overflow:hidden}
          #circuit-poster-root>main>section[data-embedded-preview="true"]{width:1280px!important;height:720px!important;min-height:0!important;margin:0!important;padding:0!important;overflow:hidden!important}
        </style></head><body class="kk-app-viewport"><div id="circuit-poster-root" inert></div>
        <script type="module" src="${attribute(script.href)}"><\/script></body></html>`;
      container.append(frame);
      timeout = setTimeout(fail, 20000);
    };
    window.addEventListener('message', event => {
      if (!frame || event.source !== frame.contentWindow || event.origin !== location.origin) return;
      if (event.data?.type !== 'kk-circuit-poster-ready') return;
      clearTimeout(timeout);
      fit();
      container.dataset.circuitPosterReady = 'true';
    });
    const observer = new IntersectionObserver(entries => {
      nearby = entries.some(entry => entry.isIntersecting);
      mount();
    }, {rootMargin: '240px 0px'});
    observer.observe(container);
    const resize = new ResizeObserver(fit);
    resize.observe(container);
    window.addEventListener('resize', fit);
    desktop.addEventListener('change', mount);
    document.addEventListener('visibilitychange', mount);
    window.addEventListener('pagehide', remove);
    window.addEventListener('pageshow', mount);
  });
})();

(() => {
  const root = document.documentElement;
  document.addEventListener('pointerdown', () => {
    root.dataset.inputModality = 'pointer';
  }, {capture: true, passive: true});
  document.addEventListener('keydown', event => {
    if (!event.metaKey && !event.ctrlKey && !event.altKey) root.dataset.inputModality = 'keyboard';
  }, {capture: true});
})();

(() => {
  const scopes = { gp1: 'GP1', gp2: 'GP2', both: 'BOTH', meister: 'MEISTER' };
  const durations = { week: '7T', month: '30T', half: '6M', life: 'LIFE' };
  const modules = ['circuit', 'fault'];
  const defaults = {
    scope_gp1: 'GP1', scope_gp2: 'GP2', scope_both: 'GP1 + GP2', scope_meister: 'Meister inkl. GP1 + GP2',
    count_gp1: '1.439 Fragen in 79 Kapiteln', count_gp2: '838 Fragen in 48 Kapiteln', count_both: '2.277 Fragen in 127 Kapiteln', count_meister: 'Meister Teil 1 & 2 plus GP1 + GP2',
    duration_week: '7 Tage Lernzugang', duration_month: '30 Tage Lernzugang', duration_half: '6 Monate Lernzugang', duration_life: 'Unbegrenzter Lernzugang',
    unavailable: 'Derzeit nicht verfügbar', choose: 'Diesen Zugang wählen', loading: 'Wird zum Warenkorb hinzugefügt …',
    error: 'Das hat leider nicht geklappt. Bitte prüfe deinen Warenkorb, bevor du es erneut versuchst.',
    saving: 'Du sparst {amount}', once: 'einmalig',
    offer_note: 'Ein vorhandener Rabattcode wird erst im Checkout auf Gültigkeit geprüft. Die angezeigten Preise enthalten keinen persönlichen Rabatt.',
    addon_circuit: 'Kältekreislauf', addon_fault: 'Störungssimulation'
  };
  const validId = value => Number.isSafeInteger(Number(value)) && Number(value) > 0;
  const validVariant = variant => variant && validId(variant.id) && Number.isSafeInteger(variant.price) && variant.price >= 0;
  function variantFor(catalog, scope, duration) {
    if (!Object.hasOwn(scopes, scope) || !Object.hasOwn(durations, duration)) return null;
    const sku = 'KK-' + durations[duration] + '-' + scopes[scope];
    return (catalog.variants || []).find(variant => variant.sku === sku && validVariant(variant)) || null;
  }
  function addonFor(catalog, moduleName) {
    if (!modules.includes(moduleName)) return null;
    return (catalog.addons || []).find(variant => variant.module === moduleName && variant.sku === 'KK-ADDON-' + moduleName.toUpperCase() && validVariant(variant)) || null;
  }
  function resolveSelection(catalog, scope, duration) {
    const selected = variantFor(catalog, scope, duration);
    if (selected?.available === true) return { scope, duration, variant: selected };
    for (const candidate of ['month', 'week', 'half', 'life']) {
      const variant = variantFor(catalog, scope, candidate);
      if (variant?.available === true) return { scope, duration: candidate, variant };
    }
    return { scope, duration, variant: null };
  }
  function purchaseItems(catalog, selection, selectedModules, strings = defaults) {
    const variant = variantFor(catalog, selection.scope, selection.duration);
    if (!validId(catalog.productId) || !variant || variant.available !== true) throw new Error('unavailable');
    const items = [{
      id: Number(variant.id), quantity: 1,
      properties: {
        'Prüfungsbereich': selection.scope === 'both' ? 'GP1 + GP2' : scopes[selection.scope],
        '_kk_access_tier': selection.duration === 'week' ? 'basic' : selection.duration === 'life' ? 'lifetime' : 'full',
        '_kk_circuit_access': 'false'
      }
    }];
    for (const moduleName of new Set(selectedModules)) {
      const addon = addonFor(catalog, moduleName);
      if (!addon || addon.available !== true) throw new Error('unavailable-addon');
      items.push({
        id: Number(addon.id), quantity: 1,
        properties: { '_kk_purchase_for': 'self', '_kk_module': moduleName, 'Zusatzmodul': strings['addon_' + moduleName] }
      });
    }
    return items;
  }
  function removalUpdates(catalog, cart) {
    if (!Array.isArray(cart?.items) || !validId(catalog.productId)) throw new Error('invalid-cart');
    const ids = new Set([...(catalog.variants || []), ...(catalog.addons || [])].filter(validVariant).map(variant => String(variant.id)));
    const knownSku = /^KK-(?:(?:7T|30T|6M|LIFE)-(?:GP1|GP2|BOTH|MEISTER)|ADDON-(?:CIRCUIT|FAULT))$/;
    const updates = {};
    cart.items.forEach(item => {
      const properties = item.properties || {};
      const otherRecipient = properties._kk_recipient_email || properties._kk_purchase_for === 'other';
      const recognized = ids.has(String(item.variant_id || item.id)) || knownSku.test(item.sku || '');
      if (String(item.product_id) === String(catalog.productId) && recognized && !otherRecipient && typeof item.key === 'string' && item.key) updates[item.key] = 0;
    });
    return updates;
  }
  function safeRoute(value) {
    if (typeof value !== 'string' || !/^\/(?!\/)[a-zA-Z0-9_./-]+$/.test(value)) throw new Error('invalid-route');
    return value.replace(/\/$/, '');
  }
  const jsonRoute = value => safeRoute(value).replace(/\.js$/, '') + '.js';
  async function replaceOwnAccess(catalog, items, fetcher, navigate) {
    const cartUrl = safeRoute(catalog.cartUrl);
    const cartReadUrl = jsonRoute(catalog.cartUrl);
    const cartUpdateUrl = jsonRoute(catalog.cartUpdateUrl);
    const cartAddUrl = jsonRoute(catalog.cartAddUrl);
    const read = await fetcher(cartReadUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!read.ok) throw new Error('cart');
    const updates = removalUpdates(catalog, await read.json());
    const request = body => ({ method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    if (Object.keys(updates).length) {
      const updated = await fetcher(cartUpdateUrl, request({ updates }));
      if (!updated.ok) throw new Error('update');
    }
    const added = await fetcher(cartAddUrl, request({ items: [...items].reverse() }));
    if (!added.ok) throw new Error('add');
    navigate(cartUrl);
  }
  function initialize(document, window) {
    const catalogNode = document.querySelector('script[data-kk-release-catalog]');
    const purchase = document.querySelector('[data-release-purchase]');
    const dialog = document.querySelector('[data-release-addons]');
    if (!catalogNode || !purchase || !dialog || purchase.dataset.releaseInitialized) return;
    purchase.dataset.releaseInitialized = 'true';
    const query = selector => document.querySelector(selector);
    const all = selector => Array.from(document.querySelectorAll(selector));
    let catalog;
    let strings;
    try {
      catalog = JSON.parse(catalogNode.textContent);
      const provided = JSON.parse(query('script[data-kk-release-strings]')?.textContent || '{}');
      strings = Object.fromEntries(Object.entries(defaults).map(([key, fallback]) => [key, typeof provided[key] === 'string' && provided[key] ? provided[key] : fallback]));
      if (!validId(catalog.productId) || !Array.isArray(catalog.variants) || !Array.isArray(catalog.addons)) throw new Error('catalog');
      safeRoute(catalog.cartUrl);
      safeRoute(catalog.cartAddUrl);
      safeRoute(catalog.cartUpdateUrl);
    } catch {
      purchase.disabled = true;
      purchase.textContent = defaults.unavailable;
      return;
    }
    const currency = /^[A-Z]{3}$/.test(catalog.currency) ? catalog.currency : 'EUR';
    let formatter;
    try { formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency }); }
    catch { formatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); }
    const money = cents => formatter.format(cents / 100);
    const setText = (selector, value) => { const node = query(selector); if (node) node.textContent = value; };
    const setHidden = (selector, value) => { const node = query(selector); if (node) node.hidden = value; };
    const setPrice = (selector, cents) => {
      const node = query(selector);
      if (!node) return;
      if (cents === null) { node.textContent = strings.unavailable; return; }
      const parts = formatter.formatToParts(cents / 100);
      node.replaceChildren(...parts.map(part => {
        if (part.type !== 'currency') return document.createTextNode(part.value);
        const small = document.createElement('small');
        small.textContent = part.value;
        return small;
      }));
    };
    const scopesInputs = all('[name="scope"]');
    const durationInputs = all('[name="duration"]');
    const addonInputs = all('[data-release-addon]');
    const controls = all('[data-release-confirm],[data-release-skip],[data-release-close]');
    let busy = false;
    let current = null;
    const error = query('[data-release-error]');
    function clearError() { if (error) { error.hidden = true; error.textContent = ''; } }
    function updatePlan() {
      const selectedScope = scopesInputs.find(input => input.checked)?.value || 'both';
      const selectedDuration = durationInputs.find(input => input.checked)?.value || 'month';
      current = resolveSelection(catalog, selectedScope, selectedDuration);
      scopesInputs.forEach(input => {
        input.disabled = busy || !Object.keys(durations).some(duration => variantFor(catalog, input.value, duration)?.available === true);
      });
      durationInputs.forEach(input => {
        const variant = variantFor(catalog, selectedScope, input.value);
        input.disabled = busy || variant?.available !== true;
        input.closest('label').hidden = !variant;
        input.checked = current.variant !== null && current.duration === input.value;
        setText('[data-duration-price="' + input.value + '"]', variant ? money(variant.price) : '');
        const compare = variant?.compareAtPrice;
        const hasSaving = Number.isSafeInteger(compare) && compare > variant.price;
        setText('[data-duration-old="' + input.value + '"]', hasSaving ? money(compare) : '');
        setHidden('[data-duration-old="' + input.value + '"]', !hasSaving);
      });
      const title = strings['scope_' + selectedScope] || strings.unavailable;
      const duration = strings['duration_' + current.duration] || '';
      setText('[data-plan-title]', title);
      setText('[data-plan-duration]', duration);
      setText('[data-plan-count]', strings['count_' + selectedScope] || '');
      setPrice('[data-price]', current.variant?.price ?? null);
      const compare = current.variant?.compareAtPrice;
      const hasSaving = current.variant && Number.isSafeInteger(compare) && compare > current.variant.price;
      setText('[data-old-price]', hasSaving ? money(compare) : '');
      setHidden('[data-old-price]', !hasSaving);
      setText('[data-plan-saving]', hasSaving ? strings.saving.replace('{amount}', money(compare - current.variant.price)) : '');
      setHidden('[data-plan-saving]', !hasSaving);
      setHidden('[data-full-feature]', current.duration === 'week');
      setHidden('[data-duration-note]', current.duration !== 'week');
      const summary = title + ' · ' + duration + ' · ' + (current.variant ? money(current.variant.price) + ' ' + strings.once : strings.unavailable);
      setText('[data-selection-note]', summary);
      setText('[data-release-plan]', summary);
      purchase.disabled = busy || !current.variant;
      purchase.textContent = busy ? strings.loading : current.variant ? strings.choose : strings.unavailable;
      addonInputs.forEach(input => {
        const addon = addonFor(catalog, input.dataset.releaseAddon);
        input.disabled = busy || addon?.available !== true;
        if (addon?.available !== true) input.checked = false;
        setText('[data-release-addon-price="' + input.dataset.releaseAddon + '"]', addon ? money(addon.price) : strings.unavailable);
      });
      controls.forEach(button => { button.disabled = busy; });
    }
    function setBusy(value) {
      busy = value;
      dialog.setAttribute('aria-busy', String(value));
      updatePlan();
    }
    function closeDialog() { if (!busy) dialog.close(); }
    async function submit(withoutExtras) {
      if (busy || !current?.variant) return;
      clearError();
      let items;
      try {
        const selectedModules = withoutExtras ? [] : addonInputs.filter(input => input.checked && !input.disabled).map(input => input.dataset.releaseAddon);
        items = purchaseItems(catalog, current, selectedModules, strings);
        setBusy(true);
        await replaceOwnAccess(catalog, items, (...args) => window.fetch(...args), url => window.location.assign(url));
      } catch {
        setBusy(false);
        if (error) { error.hidden = false; error.textContent = strings.error; }
      }
    }
    [...scopesInputs, ...durationInputs].forEach(input => input.addEventListener('change', () => { clearError(); updatePlan(); }));
    purchase.addEventListener('click', () => {
      if (busy || !current?.variant) return;
      clearError();
      addonInputs.forEach(input => { input.checked = false; });
      updatePlan();
      dialog.showModal();
    });
    all('[data-release-close]').forEach(button => button.addEventListener('click', closeDialog));
    query('[data-release-confirm]')?.addEventListener('click', () => submit(false));
    query('[data-release-skip]')?.addEventListener('click', () => submit(true));
    dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog();
    });
    const offerNote = query('[data-release-offer-note]');
    if (offerNote) {
      offerNote.hidden = !new URLSearchParams(window.location.search).has('kk-offer');
      offerNote.textContent = strings.offer_note;
    }
    window.addEventListener('pageshow', event => {
      if (event.persisted) setBusy(false);
    });
    updatePlan();
  }
  if (typeof module === 'object' && module.exports) {
    module.exports = { variantFor, addonFor, resolveSelection, purchaseItems, removalUpdates, safeRoute, replaceOwnAccess, initialize, defaults };
  } else if (typeof document !== 'undefined') {
    initialize(document, window);
  }
})();

(() => {
  const selector = '.section-heading, .brand-values__intro, .kk-exam__copy, .faq-section > div:first-child';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new Set();
  const active = new Map();
  const viewportHeight = () => document.documentElement.clientHeight || window.innerHeight;
  let observer;

  const show = accent => {
    accent.dataset.scrollAccent = 'shown';
    pending.delete(accent);
    observer?.unobserve(accent);
  };
  const stopActive = () => {
    active.forEach((animation, accent) => {
      show(accent);
      animation.cancel();
    });
    active.clear();
  };
  const showAll = () => {
    stopActive();
    [...pending].forEach(show);
  };
  const reveal = accent => {
    if (!pending.has(accent)) return;
    show(accent);
    if (reduced.matches || document.hidden || typeof accent.animate !== 'function') return;
    // Only this decorative line fades; page content never moves or disappears.
    try {
      const animation = accent.animate([{opacity: .16}, {opacity: .72}], {
        duration: 800,
        easing: 'cubic-bezier(.2,.6,.3,1)'
      });
      active.set(accent, animation);
      const release = () => active.delete(accent);
      animation.finished.then(release, release);
    } catch {
      // The static, fully shown accent remains when Web Animations is unavailable.
    }
  };

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const accent = entry.target;
        if (!pending.has(accent)) return;
        const top = entry.boundingClientRect.top;
        const bottom = entry.rootBounds?.bottom ?? viewportHeight() - 56;
        const upper = entry.rootBounds?.top ?? 0;
        if (top < upper) {
          // A quick scroll has already passed this section. Do not animate it later.
          show(accent);
        } else if (entry.isIntersecting && top <= bottom) {
          reveal(accent);
        }
      });
    }, {rootMargin: '0px 0px -56px 0px', threshold: 0});
  }

  document.querySelectorAll(selector).forEach(host => {
    if (host.querySelector('[data-scroll-accent]')) return;
    const accent = document.createElement('span');
    accent.className = 'kk-scroll-accent';
    accent.setAttribute('aria-hidden', 'true');
    host.classList.add('kk-scroll-accent-host');
    host.append(accent);
    const top = accent.getBoundingClientRect().top;
    if (!observer || reduced.matches || document.hidden || top < viewportHeight()) {
      show(accent);
      return;
    }
    accent.dataset.scrollAccent = 'waiting';
    pending.add(accent);
    observer.observe(accent);
  });

  reduced.addEventListener('change', () => {
    if (reduced.matches) showAll();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopActive();
  });
  window.addEventListener('pagehide', showAll);
  window.addEventListener('resize', () => {
    stopActive();
    // Resizing or rotating into a section is not a scroll entrance.
    [...pending].forEach(accent => {
      if (accent.getBoundingClientRect().top < viewportHeight()) show(accent);
    });
  }, {passive: true});
})();

"use strict";
(() => {
  const dock=document.querySelector('[data-access-dock]');
  const trigger=document.querySelector('[data-access-trigger]');
  const pricing=document.getElementById('preise');
  if(!dock||!trigger||!pricing||dock.dataset.accessReady||!('IntersectionObserver' in window))return;
  let triggerKnown=false;
  let pricingKnown=false;
  let lastVisible=null;
  let framePending=false;
  const update=()=>{
    const visible=triggerKnown&&pricingKnown&&!document.hidden&&trigger.getBoundingClientRect().bottom<=0&&pricing.getBoundingClientRect().top>window.innerHeight;
    if(visible===lastVisible)return;
    lastVisible=visible;
    dock.classList.toggle('is-visible',visible);
    dock.toggleAttribute('inert',!visible);
    dock.setAttribute('aria-hidden',String(!visible));
    dock.tabIndex=visible?0:-1;
  };
  const scheduleUpdate=()=>{
    if(framePending)return;
    framePending=true;
    requestAnimationFrame(()=>{
      framePending=false;
      update();
    });
  };
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.target===trigger){
        triggerKnown=true;
      }
      if(entry.target===pricing){
        pricingKnown=true;
      }
    });
    update();
  },{threshold:0});
  dock.dataset.accessReady='true';
  update();
  dock.hidden=false;
  observer.observe(trigger);
  observer.observe(pricing);
  document.addEventListener('scroll',scheduleUpdate,{passive:true});
  window.addEventListener('resize',scheduleUpdate,{passive:true});
  document.addEventListener('visibilitychange',update);
})();

;
"use strict";
(() => {
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const controllers=[];
  document.querySelectorAll('.faq-list > details').forEach(details=>{
    const summary=details.querySelector(':scope > summary');
    if(!summary||details.dataset.faqMotion||typeof details.animate!=='function')return;
    let animation=null;
    let targetOpen=details.open;
    const stop=()=>{
      if(!animation)return;
      const previous=animation;
      animation=null;
      previous.onfinish=null;
      previous.oncancel=null;
      previous.cancel();
    };
    const settle=(open=targetOpen)=>{
      stop();
      targetOpen=open;
      details.open=open;
      details.style.removeProperty('height');
      delete details.dataset.faqAnimating;
      summary.setAttribute('aria-expanded',String(open));
    };
    summary.addEventListener('click',event=>{
      if(event.defaultPrevented||event.button>0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.target.closest('a,button,input,select,textarea'))return;
      event.preventDefault();
      const next=!(animation?targetOpen:details.open);
      if(reduced.matches){settle(next);return;}
      const start=details.getBoundingClientRect().height;
      stop();
      targetOpen=next;
      details.style.removeProperty('height');
      details.open=true;
      const style=getComputedStyle(details);
      const edges=['paddingTop','paddingBottom','borderTopWidth','borderBottomWidth'].reduce((sum,key)=>sum+(parseFloat(style[key])||0),0);
      const end=next?details.getBoundingClientRect().height:summary.getBoundingClientRect().height+edges;
      summary.setAttribute('aria-expanded',String(next));
      if(Math.abs(end-start)<1){settle(next);return;}
      details.style.height=start+'px';
      details.dataset.faqAnimating='true';
      const current=details.animate([{height:start+'px'},{height:end+'px'}],{duration:320,easing:'cubic-bezier(.22,1,.36,1)'});
      animation=current;
      current.onfinish=()=>{if(animation===current)settle(next);};
      current.oncancel=()=>{if(animation===current)settle(next);};
    });
    details.addEventListener('toggle',()=>{
      if(animation)return;
      targetOpen=details.open;
      summary.setAttribute('aria-expanded',String(targetOpen));
    });
    details.dataset.faqMotion='true';
    summary.setAttribute('aria-expanded',String(targetOpen));
    controllers.push(()=>{if(animation)settle();});
  });
  if(!controllers.length)return;
  const settleAll=()=>controllers.forEach(settle=>settle());
  window.addEventListener('resize',settleAll,{passive:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)settleAll();});
  reduced.addEventListener('change',()=>{if(reduced.matches)settleAll();});
})();

;
"use strict";
(() => {
  const scenes=Array.from(document.querySelectorAll('[data-cold-draft]:not([data-drift-ready])'));
  if(!scenes.length||!('IntersectionObserver' in window))return;
  const motifs=scenes.flatMap(scene=>Array.from(scene.querySelectorAll('.kk-cold-motif')));
  const visible=new Set();
  const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
  const update=()=>{
    const allowed=!document.hidden&&!preference.matches;
    motifs.forEach(motif=>{
      if(preference.matches){motif.classList.add('is-settled','is-revealed');}
      else if(allowed&&visible.has(motif))motif.classList.add('is-revealed');
      motif.classList.toggle('is-drifting',allowed&&visible.has(motif));
    });
  };
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting)visible.add(entry.target);
      else visible.delete(entry.target);
    });
    update();
  },{threshold:0});
  scenes.forEach(scene=>{scene.dataset.driftReady='true';});
  update();
  motifs.forEach(motif=>observer.observe(motif));
  document.addEventListener('visibilitychange',update);
  preference.addEventListener('change',update);
})();
